import React, { useState, useEffect } from 'react';
import RegistrationForm from '../components/registration.form';
import ActivityForm from '../components/activity.form';
import LoadingButton from '@mui/lab/LoadingButton';

const Home = ({ reCAPTCHAActive, registrationStatus }) => {
    const [loading, setLoading] = useState(true);
    const [registrationType, setRegistrationType] = useState(-1);
    const [goBack, setGoBack] = useState(true);
   
    useEffect(() => {
        if (registrationStatus.spainCompetitions > 0 && registrationStatus.summerTourCompetitions === 0 && registrationStatus.activities === 0) {
            setRegistrationType(1);
            setGoBack(false);
        } else if (registrationStatus.summerTourCompetitions > 0 && registrationStatus.spainCompetitions === 0 && registrationStatus.activities === 0) {
            setRegistrationType(3);
            setGoBack(false);
        } else if (registrationStatus.activities > 0 && registrationStatus.spainCompetitions === 0 && registrationStatus.summerTourCompetitions === 0) {
            setRegistrationType(2);
            setGoBack(false);
        } else if (registrationStatus.activities === 0 && registrationStatus.spainCompetitions === 0 && registrationStatus.summerTourCompetitions === 0) {
            setRegistrationType(4);
        }
        setLoading(false);
    }, [registrationStatus.activities, registrationStatus.spainCompetitions, registrationStatus.summerTourCompetitions]);

    return (
        <div className='form-wrapper'>
            {loading === true && <h3 className='s4g-select-competition-type-header'>Laddar sidan, vänligen vänta lite...</h3>}
            {loading === false && registrationType === -1 && <div>
                <h3 className='s4g-select-competition-type-header'>Vad vill du anmäla dig till?</h3>
                <div className='s4g-select-competition-type'>
                    {registrationStatus.spainCompetitions > 0 && <LoadingButton variant="contained" onClick={() => setRegistrationType(1)}>Tävlingar</LoadingButton>}
                    {registrationStatus.activities > 0 && <LoadingButton variant="contained" onClick={() => setRegistrationType(2)}>Aktiviteter</LoadingButton>}
                    {registrationStatus.summerTourCompetitions > 0 && <LoadingButton variant="contained" onClick={() => setRegistrationType(3)}>Sommartouren</LoadingButton>}
                </div>
            </div>}
            {loading === false && registrationType === 1 &&
                <RegistrationForm competitionType={1} reCAPTCHAActive={reCAPTCHAActive} goBack={goBack} resetRegistrationType={() => setRegistrationType(-1)} />}
            {loading === false && registrationType === 2 &&
                <ActivityForm reCAPTCHAActive={reCAPTCHAActive} goBack={goBack} resetRegistrationType={() => setRegistrationType(-1)} />}
            {loading === false && registrationType === 3 &&
                <RegistrationForm competitionType={2} reCAPTCHAActive={reCAPTCHAActive} goBack={goBack} resetRegistrationType={() => setRegistrationType(-1)} />}
            {loading === false && registrationType === 4 &&
                <h3 className='s4g-select-competition-type-header'>Det finns inget att anmäla sig till just nu</h3>}
        </div>
    );
}

export default Home;
